import React from 'react';
import './JogadoresScreen.css';

import Carregando from '../../components/Carregando';
import Jogador from '../../components/Jogador';

import Campeonato from '../../services/Campeonato';
import env from '../../constants/env';

export default class JogadoresScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      jogadores: [],
    };
  }

  componentDidMount() {
    this.inicializar();
  }

  async inicializar() {
    const { campeonato = env.CAMPEONATO } = this.props;
    if (process.env.NODE_ENV === 'development') {
      await Campeonato.cadastrarJogadores(campeonato);
    }
    const jog = await Campeonato.listarJogadores();
    const qtdeCaract = `${env.PREFIX_JOGADORES}`.length
    const jogadores = jog.filter(j => j[0].substring(0, qtdeCaract) === env.PREFIX_JOGADORES);
    await this.setState({ loading: false, jogadores });
  }

  listarJogadores() {
    const { jogadores } = this.state;
    const lista = jogadores.map(jogador => <Jogador key={jogador[1].id} jogador={jogador[1]} acompanhamento={false} acaoAtiva={false} />);
    console.log('Campeonato.semFoto', Campeonato.semFoto);
    return lista;
  }

  render() {
    const { loading } = this.state;

    if (loading) {
      return <Carregando />;
    }

    return (
      <div className="App">
        <div className="ListaJogadores">{this.listarJogadores()}</div>
      </div>
    );
  }
}
